// Ties an order to the creator whose link brought the visitor, even when the creator's code
// cannot discount the order (custom colours are excluded from every code).
// /discount/CODE sets a session cookie, discount_code. While that cookie or a remembered code is
// active, the code goes on the cart as the attribute "Creator" and on every add-to-cart form as the
// hidden line property "_Creator", which also covers express checkout on the product page.
// The code is remembered for 30 days from the click only if the visitor allows marketing cookies.
(function () {
  if (window.__leCreator) return;
  window.__leCreator = true;

  var KEY = 'le-creator';
  var DAYS = 30;
  var SHOP_CODES = { EARS10: 1, EXTRA15: 1 };

  function fromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    var c = m ? decodeURIComponent(m[1]).toUpperCase() : '';
    return c && !SHOP_CODES[c] ? c : '';
  }
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; }
  }
  function write(entry) {
    try { localStorage.setItem(KEY, JSON.stringify(entry)); } catch (e) {}
  }
  function forget() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  var cookieCode = fromCookie();
  var clicked = /[?&]utm_medium=influencer(&|$)/.test(location.search);
  var stored = read();
  var expired = !!stored && Date.now() - stored.at > DAYS * 864e5;
  if (expired) { forget(); stored = null; }
  var code = cookieCode || (stored && stored.code) || '';

  function cart(path, body) {
    return fetch('/' + path, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function syncCart() {
    cart('cart.js').then(function (c) {
      var now = (c.attributes && c.attributes.Creator) || '';
      if (now !== code) return cart('cart/update.js', { attributes: { Creator: code } });
    }).catch(function () {});
  }
  function tagForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (f.querySelector('input[name="properties[_Creator]"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[_Creator]';
      i.value = code;
      f.appendChild(i);
    });
  }

  function remember() {
    if (!cookieCode) return;
    if (!stored || stored.code !== cookieCode || clicked) write({ code: cookieCode, at: Date.now() });
  }
  function watchConsent() {
    document.addEventListener('visitorConsentCollected', function (e) {
      if (e.detail && e.detail.marketingAllowed) remember(); else forget();
    });
    if (!window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !Shopify.customerPrivacy) return;
      if (Shopify.customerPrivacy.marketingAllowed()) remember();
      else if (Shopify.customerPrivacy.currentVisitorConsent().marketing === 'no') forget();
    });
  }

  if (cookieCode || stored) watchConsent();
  if (expired && !code) { cart('cart/update.js', { attributes: { Creator: '' } }).catch(function () {}); }
  if (!code) return;

  syncCart();
  tagForms();
  new MutationObserver(tagForms).observe(document.body, { childList: true, subtree: true });
})();
